import { render, staticRenderFns } from "./mainEntry.vue?vue&type=template&id=63856034&scoped=true&"
import script from "./mainEntry.vue?vue&type=script&lang=js&"
export * from "./mainEntry.vue?vue&type=script&lang=js&"
import style0 from "./mainEntry.vue?vue&type=style&index=0&id=63856034&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63856034",
  null
  
)

export default component.exports